import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import DrywallHero from './components/DrywallHero';
import DrywallServices from './components/DrywallServices';
import DrywallTypesElPaso from './components/DrywallTypesElPaso';
import ContractorDirectory from './components/ContractorDirectory';
import ComparisonChecklist from './components/ComparisonChecklist';
import DrywallFAQ from './components/DrywallFAQ';

const Drywall = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <DrywallHero />
      <DrywallServices />
      <DrywallTypesElPaso />
      <ContractorDirectory />
      <ComparisonChecklist />
      <DrywallFAQ />
      <Footer />
    </div>
  );
};

export default Drywall;
